import { useState } from "react";
import { Input, Select } from "antd";
import { get, isNil } from "lodash";
import PropTypes from "prop-types";
import { CURRENT_SET_FIELD, NO_ACTION } from "./slot-editing";
import { answerText } from "./workshop-preview";

const choicesOf = (field) =>
  (get(field, "options") || [])
    .map((option) =>
      typeof option === "object"
        ? { value: option.value, label: option.label || String(option.value) }
        : { value: option, label: String(option) },
    )
    .filter((option) => !isNil(option.value) && option.value !== "");

export const SampleAnswer = ({ answer, field, disabled, onChange }) => {
  const shown = answerText(answer.value);
  const [text, setText] = useState(shown);
  const choices = choicesOf(field);
  const commit = () => {
    if (text === shown) return;
    onChange(text);
  };
  return (
    <label className="workshop-sample__answer">
      <span className="workshop-sample__field">{answer.field}</span>
      {choices.length ? (
        <Select
          virtual={false}
          className="workshop-select"
          aria-label={answer.field}
          options={choices}
          value={answer.value}
          disabled={disabled}
          onChange={onChange}
        />
      ) : (
        <Input
          aria-label={answer.field}
          value={text}
          disabled={disabled || Array.isArray(answer.value)}
          onChange={(event) => setText(event.target.value)}
          onBlur={commit}
          onPressEnter={commit}
        />
      )}
    </label>
  );
};

SampleAnswer.propTypes = {
  answer: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any,
  }).isRequired,
  field: PropTypes.object,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

SampleAnswer.defaultProps = {
  field: null,
  disabled: false,
};

export const actionOption = (option) => (
  <span className="workshop-option">
    <span className="workshop-option__label">{option.data.label}</span>
    {option.data.description ? (
      <span className="workshop-option__note">{option.data.description}</span>
    ) : null}
  </span>
);

export const choiceOf = ({
  actionChanged,
  chosenSwitch,
  draftAction,
  keptSetField,
}) => {
  if (!actionChanged) return {};
  if (chosenSwitch) return { setField: chosenSwitch.setField };
  if (draftAction === CURRENT_SET_FIELD) {
    return keptSetField ? { setField: keptSetField } : {};
  }
  return { action: draftAction === NO_ACTION ? "" : draftAction };
};
